<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Dodeli kontrole {{$route.query.title}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
		<div>
		Podshema:
		<dropdownlist
		:data-items="sifrant['podrocjaip']"
                :text-field="'naziv'"
				v-model="podshema"
				@change="podrocjeChange"
				>


		</dropdownlist>
		</div>
		<div>
		Kontrolor: 
		<dropdownlist
		
		:data-items=kontrolorji
                :text-field="'naziv'"
				v-model="kontrolor"

               
               
				>

		</dropdownlist>
		</div>
		
		<div>
		Status nadzora
		<dropdownlist
		:data-items="sifrant['statusnadzora']"
                :text-field="'naziv'"
				v-model="statusnadzora"
>

		</dropdownlist>
		</div>
        <div>
		Rok izvedbe
        <kendo-datepicker id="rokizvedbe"
                       v-model="rokizvedbe"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
		</div>
	</div>
	<div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
						selected-field="izbran"
                        :pageable="{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        @selectionchange="onSelectionChange"
        				@headerselectionchange="onHeaderSelectionChange"
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                 
                      <template v-slot:uredi="{props}">
                      <td><kbutton theme-color="primary" @click="uredikontrolo(props.dataItem)" ><font-awesome-icon :icon="'list-check'"/> </kbutton>
                      </td>
                    </template>
                    <template v-slot:shemaCell="{props}">
                      <shemaCell :sheme="props.dataItem.sheme.filter(s=>(s.jeaktivna&&s.sezona==$trenutnasezona&&s.shema!='IP'))"/>
                    </template>
                        <toolbar>
                             
                        <kbuttongroup>
                            <kbutton 
                                title="Izvozi v Excel"
                                @click="exportExcel"
                                theme-color="primary"
                            >
                                Izvozi v Excel
                            </kbutton>
                            <kbutton 
                               
                                title="Dodeli kontrole"
                                @click="dodelikontrole"
                                theme-color="primary"
                            >
                                Dodeli kontorle kontrolorju
                            </kbutton>    
                        </kbuttongroup>
						Število izbranih strank: {{ stizbranih }}
                        
                            
                        </toolbar>
                    </Grid>
					<div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
					</div>
                    </div>
    </div>

</template>
<style scoped>
.grid-wrapper {
        position: relative;
    }
    .shema-loader {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 4rem;
        background-color: rgba(255,255,255,.5);
        color: var(--accent);
        text-align: center;
      }
</style>
<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library

//št_leto_ip /šifra
import { DatePicker, DateTimePicker } from '@progress/kendo-vue-dateinputs';
//dodeli tudi vzorčenje
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { kontrolaService } from '../services/kontrola.service';
import ShemaCell from './support/ShemaCell';

import { process } from '@progress/kendo-data-query';
 


export default {
    components:{
      
      'multiselect': MultiSelect, 
      'shemaCell': ShemaCell,
      'kendo-datepicker': DatePicker,
      'kbutton': Button,
      'kbuttongroup': ButtonGroup,
      'Grid': Grid,
      'toolbar': GridToolbar,
      'dropdownlist': DropDownList,
    },
  props:['shema','sezona'],
    data () {
        return {
         
            dataSezona:this.sezona,
			podshema:null,
			kontrolor:null,
			vrstakontrole:null,
			statusnadzora:null,
            rokizvedbe:null,

            


            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
            hiddenColumns2:[],
			gridData:[],
			rawData:[],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
           
          

           

        }
    },
    created () {

      
      /*
   
        if(!this.$route.query.sezona)
            this.dataSezona={sezona:2022};
        else
            this.dataSezona={sezona:this.$route.query.sezona};


     this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
     */
     this.naloziPodatke(this.shema,this.sezona);
 
    },
      beforeRouteUpdate (to, from,next) {
        
        this.naloziPodatke(to.query.title,to.query.sezona,next);

        /*
        if(!to.query.sezona)
            this.dataSezona={sezona:2023};
        else
            this.dataSezona={sezona:to.query.sezona};
        
       //this.naloziPodatke(to.query.title,to.query.sezona,next);
       
       this.loadVse({sezona:this.dataSezona.sezona,shema:to.query.title});
       */
    

 
    },
    computed: {
		kontrolorji(){
			if(this.podshema)
				return this.sifrant["kontrolorjiip"].filter(s=>(s.podrocje.indexOf(this.podshema.naziv)>=0))
			else
				return this.sifrant["kontrolorjiip"]
			
		},
		stizbranih(){
			return this.gridData.filter(i=>i.izbran).length;
		},
        columns() {

let  columns=[

			   { field: 'izbran', width: '50px', headerSelectionValue: this.soVsiIzbrani,filterable:false },
               { field: "podrocjecertificiranja", title:"Podsheme stranke",width: "140px",filterable:false},
               { field: "sheme", title:"Druge sheme",cell:"shemaCell",filterable:false,width: "120px",},
			   { field: "izvajalec", title:"Izvajalec"},
			   { field: "naslov", title:"Naslov"},
			   { field: "postnastevilka", title:"Poštna številka"},
			   { field: "posta", title:"Pošta"},
               { field: "status", title:"Status nadzora"},
               { field: "podshema", title:"Podshema nadzora"},
               { field: "kontrolor", title:"Kontrolor"},
               { field: "rokizvedbe", title:"Rok izvedbe",type:"date",format:"{0:d}"},
			 

            ];
  


this.hiddenColumns2=columns.filter(c=>c.hidden);
return columns;


},

         
...mapState('users', ['userDetails','sezoneBranje']),
...mapState('sifrant', ['sifrant']) ,
         
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {
		onHeaderSelectionChange (event) {
            let checked = event.event.target.checked;
			this.gridData.forEach(element => {
                
                if(element.podrocjecertificiranja.length>0)
				    Vue.set(element,"izbran",checked);
			});
            
        },
        onSelectionChange (event) {
            console.log(event.dataItem)
            if(event.dataItem.podrocjecertificiranja.length>0)
            event.dataItem.izbran = !event.dataItem.izbran;
        },
        onRowClick (event) {
            event.dataItem.izbran = !event.dataItem.izbran;
        },
        naloziPodatke(shema,sezona,next){

        this.loading=true;
            if(!sezona)
            this.dataSezona={sezona:this.$trenutnasezona};
        else
            this.dataSezona={sezona:parseInt(sezona)};

        var thisComp=this;
		//naloži šifrante
		var pdata=[
        
        //this.naloziSifrant({sezona:sezona,sifrant:"vrstakontroleip"}),
        this.naloziSifrant({sezona:sezona,sifrant:"kontrolorjiip"}),
        this.naloziSifrant({sezona:sezona,sifrant:"statusnadzora"}),
        this.naloziSifrant({sezona:sezona,sifrant:"podrocjaip"})]
        
        Promise.all(pdata).then(()=>{

		kontrolaService.loadZaDodeljevanje(sezona,shema).then(
			data=>{
				
            for (let p of data){
                let kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg")
                if(!kontakt)
                    kontakt=p.kontakt.find(k=>k.glavni)
                if(!kontakt)
                    kontakt=p.kontakt[0];
                
				let ip=p.sheme.find(s=>s.shema==shema&&s.sezona==sezona).ip;
				if(ip.podrocjacertificiranja)
				Vue.set(p,"podrocjecertificiranja",ip.podrocjacertificiranja.filter(p=>p.status.naziv=='aktiven').map(p=>p.naziv)).join(",");
                Vue.set(p,"izvajalec",kontakt.naziv);
                Vue.set(p,"naslov",kontakt.naslov);
				Vue.set(p,"posta",kontakt.posta);
				Vue.set(p,"postnastevilka",kontakt.postnastevilka);
                Vue.set(p,"podshema",p.kontrole?.podrocjecertificiranja);
				Vue.set(p,"status",p.kontrole?.status);
				Vue.set(p,"kontrolor",p.kontrole?.kontrolornaziv);
                Vue.set(p,"rokizvedbe",p.kontrole?.rokizvedbe);
				Vue.set(p,"izbran",0);
				
            }
			Vue.set(thisComp,"gridData",data);
			Vue.set(thisComp,"rawData",data);
			this.loading=false;
			//console.log(data);
			if(next)
                next();
		},
		err=>{console.log("Pri nalaganju je napaka!!!")}
		)
	});
        
    }
        ,
        ...mapActions('kontrola', ['loadVse']),
		...mapActions({naloziSifrant: 'sifrant/load'}),
       
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število:']);
        },
        nogaSteviloKontrol: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.length,"n0")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
        sezonaChange(event) {
            const sezona = event.value;
            
            this.$router.push({ path: this.$route.path, query: { sezona:sezona.sezona,title:this.$route.query.title} })
            this.dataSezona=sezona;
            //this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


        },
		podrocjeChange(event) {
          
			Vue.set(this,"gridData",this.rawData.filter(d=>d.podrocjecertificiranja.indexOf(this.podshema.naziv)>=0))
            //this.loadVse({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
         
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
      
        exportExcel () {
            this.saveExcel({
                data: this.dataResult.data,
                fileName: this.dataSezona.sezona+"_KONTROLE",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },
        dodelikontrole () {
            //this.$router.push({ name: "dodelikontroleip", params: { sezona:sezona.this.dataSezona.sezona,shema:this.$route.query.title} })

			
			let izbrani=this.gridData.filter(i=>i.izbran);
			console.log(izbrani);
			let kontrole={
				kontrolor:this.kontrolor,
				podshema:this.podshema,
                rokizvedbe:this.rokizvedbe,
				//vrstakontrole:this.vrstakontrole,
				status:this.statusnadzora,
				pridelovalci:izbrani
			}
			kontrolaService.dodeliKontrole(this.dataSezona.sezona,this.shema,kontrole).then(
				(data)=>{console.log(data)},
				(data)=>{console.log(data)}
				)
			//filter še
			//če daš nedoločeno, doda novo kontrolo
			//pošlji izbrane in podatke na server, naredi tam loop in ustvari kontrole... //Deselectaj

			//deselectaj, in naloži podatke
			this.naloziPodatke(this.shema,this.dataSezona.sezona);
           
        },
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

